import { useModalTrainingPlayer } from '../ui';

export const useStartTraining = () => {
  const startTraining = useModalTrainingPlayer();
  return [startTraining];
};
